"use client";

import Modal from "@/components/ui/modal";
import EditorLinkUpload from "./editor-link-upload";
import { useCustomEditor } from "@/providers/custom-editor-provider";

const EditorLinkUploadModal = () => {
	const { isLinkUploaderOpen, closeLinkUploader } = useCustomEditor();

	return (
		<Modal
			title="Add Links"
			isOpen={isLinkUploaderOpen}
			onClose={closeLinkUploader}
			className="max-w-3xl"
		>
			<EditorLinkUpload />
		</Modal>
	);
};

export default EditorLinkUploadModal;
